import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { ActivityType, ActivityTypeId } from '@/lib/api/company/chartScan/types'
import { getActivityIcon } from '@/modules/drivers/helpers/ActivityIconResolver'
import { ACTIVITY_LABEL_KEYS, ChartT, useChartT } from '../i18n'
import { CHART_ADDING_MODES } from './chartActivityModes'

function modeLabel(T: ChartT, type: ActivityTypeId): string {
  const meta = ACTIVITY_LABEL_KEYS[type]
  if (type === ActivityType.NoData) return T('actNoDataShort', 'Brak')
  return T(meta.key, meta.def)
}

type Props = {
  addingMode: ActivityTypeId | null
  onChangeMode: (mode: ActivityTypeId | null) => void
}

export function ChartActivityModeButtons({ addingMode, onChangeMode }: Props) {
  const T = useChartT()
  return (
    <div className="tw-flex tw-gap-1">
      {CHART_ADDING_MODES.map((m) => {
        const active = addingMode === m.type
        return (
          <button
            key={m.type}
            type="button"
            onClick={() => onChangeMode(active ? null : m.type)}
            title={`${modeLabel(T, m.type)} (${m.digit})`}
            className={[
              'tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded tw-border',
              active
                ? 'tw-border-slate-700 tw-shadow-inner'
                : 'tw-border-slate-300 hover:tw-border-slate-500',
            ].join(' ')}
            style={active ? { backgroundColor: m.color } : undefined}
          >
            <FontAwesomeIcon
              icon={getActivityIcon(m.type) as IconProp}
              className="tw-text-base"
              style={{ color: active ? '#0f172a' : m.color }}
            />
          </button>
        )
      })}
    </div>
  )
}
